<div class="row">
    <div class="col-12">
        <div class="card card-body">
            <div class="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 class="card-title">Instant Access Details</h4>

                </div>
                <div>
                    <button class="btn btn-primary" (click)="openModal(accessModal)">
                        <i class="fas fa-plus mr-2"></i>Add New Access
                    </button>

                </div>
            </div>

            <div *ngIf="loading" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <p class="mt-2">Loading access records...</p>
            </div>

            <div *ngIf="!loading">
                <div *ngIf="accessRecords.length === 0" class="text-center py-5">
                    <i class="fas fa-key fa-3x text-muted mb-3"></i>
                    <p class="lead">No instant access records found for this lock</p>
                    <button class="btn btn-outline-primary mt-2" (click)="openModal(accessModal)">
                        Create New Access
                    </button>
                </div>

                <div *ngIf="accessRecords.length > 0" class="table-responsive">
                    <table class="table table-striped border">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Duration</th>
                                <th>Timing</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let record of accessRecords">
                                <td>{{ record.user_id.name }}</td>
                                <td>{{ record.email }}</td>
                                <td>{{ record.user_id.mobile }}</td>
                                <td>{{ record.duration }} {{ record.time }}</td>
                                <td>{{ record.timing }}</td>
                                <td>{{ formatDate(record.start_date) }}</td>
                                <td>{{ formatDate(record.end_date) }}</td>
                                <td>
                                    <span [ngClass]="record.isExpired ? 'badge badge-danger' : 'badge badge-success'">
                                        {{record.isExpired ? "Expired":"Active"}}
                                    </span>
                                </td>
                                <td>
                                    <a href="javascript: void(0);" class="link mr-2" placement="top"
                                        (click)="openModal(confirmDelete, record)" ngbTooltip="Delete">
                                        <i class="fas fa-trash-alt"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Access Modal -->
<ng-template #accessModal let-modal>
    <form #accessFormRef="ngForm" (ngSubmit)="submitForm(accessFormRef, modal)">
        <div class="modal-header">
            <h5 class="modal-title">{{ editMode ? 'Edit' : 'Create' }} Instant Access</h5>
            <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body">
            <p><b>{{ editMode ? 'Update' : 'Provide' }} instant asset access to user for limited time.</b></p>

            <!-- Email -->
            <div class="form-group">
                <label>Email</label>
                <input type="email" class="form-control" [(ngModel)]="accessForm.email" name="email" required email
                    #email="ngModel" placeholder="Enter email address" />
                <div class="text-danger" *ngIf="email.invalid && email.touched">
                    <small *ngIf="email.errors?.required">Email is required.</small>
                    <small *ngIf="email.errors?.email">Enter a valid email address.</small>
                </div>
            </div>

            <div class="row">
                <!-- Duration -->
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Duration</label>
                        <input type="number" class="form-control" [(ngModel)]="accessForm.duration" name="duration"
                            required min="1" max="99" #duration="ngModel" />
                        <div class="text-danger" *ngIf="duration.invalid && duration.touched">
                            <small *ngIf="duration.errors?.required">Duration is required.</small>
                            <small *ngIf="duration.errors?.min || duration.errors?.max">
                                Duration must be between 1 and 99.
                            </small>
                        </div>
                    </div>
                </div>

                <!-- Timing -->
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Timing</label>
                        <select class="form-control" [(ngModel)]="accessForm.timing" name="timing" required
                            #timing="ngModel">
                            <option value="Hour">Hour</option>
                        </select>
                        <div class="text-danger" *ngIf="timing.invalid && timing.touched">
                            <small>Timing is required.</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
            <button type="submit" class="btn btn-primary" [disabled]="accessFormRef.invalid">
                {{ editMode ? 'Update' : 'Create' }}
            </button>
        </div>
    </form>
</ng-template>

<!-- Delete Confirmation Modal -->
<ng-template #confirmDelete let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Delete</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p>Are you sure you want to delete this access record ?</p>
    </div>

    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
        <button class="btn btn-danger" (click)="confirmDeleteAccess(accessForm._id)">Delete</button>
    </div>
</ng-template>